var _defs, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommandConsole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cmdconsole_icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Command Console") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#434343;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.749,
    y1: 23.25,
    x2: 22.499,
    y2: 23.25
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.749,18.75H5.5a.5.5,0,0,1,.5.5v4a0,0,0,0,1,0,0H2.249a0,0,0,0,1,0,0v-4A.5.5,0,0,1,2.749,18.75Z",
    style: {
      fill: "rgb(237, 23, 31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.249,9.75H13a.5.5,0,0,1,.5.5v13a0,0,0,0,1,0,0H9.749a0,0,0,0,1,0,0v-13A.5.5,0,0,1,10.249,9.75Z",
    style: {
      fill: "rgb(237, 23, 31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.749,14.25H20.5a.5.5,0,0,1,.5.5v8.5a0,0,0,0,1,0,0h-3.75a0,0,0,0,1,0,0v-8.5A.5.5,0,0,1,17.749,14.25Z",
    style: {
      fill: "rgb(237, 23, 31)"
    }
  }), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.883,
    y1: 5.121,
    x2: 2.866,
    y2: 9.134
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14.311,
    y1: 6.325,
    x2: 9.637,
    y2: 5.075
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 20.392,
    y1: 2.888,
    x2: 16.811,
    y2: 5.689
  })), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8.249,
    cy: 4.501,
    r: 1.5,
    style: {
      fill: "rgb(237, 23, 31)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21.75,
    cy: 2.25,
    r: 1.5,
    style: {
      fill: "rgb(237, 23, 31)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 15.75,
    cy: 6.75,
    r: 1.5,
    style: {
      fill: "rgb(237, 23, 31)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.249,
    cy: 10.501,
    r: 1.5,
    style: {
      fill: "rgb(237, 23, 31)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandConsole);
export default __webpack_public_path__ + "static/media/CommandConsole.ef204917b20da0a91c94c68d6bd0df84.svg";
export { ForwardRef as ReactComponent };